/**
 * Toast de la fiche cours : le toast commun de la v2 (lib/toast.tsx : encre, coche verte, en haut à droite sous
 * l'en-tête réel du site), qui est l'habillage par défaut de tous les toasts de la v2.
 */
import { useToast } from '@chakra-ui/react';
import { useCallback } from 'react';

export function useClassToast() {
  const toast = useToast();
  return useCallback(
    (message: string, id?: string) => {
      if (id && toast.isActive(id)) return;
      toast({ id, title: message, status: 'success', duration: 5000 });
    },
    [toast],
  );
}
